(() => {
  'use strict';
  document.querySelectorAll('[data-amc-quote-product]').forEach(root => {
    const box = root.querySelector('[data-uspe-structured-options]');
    if (!box || box.dataset.ready) return;
    const native = root.querySelector('[data-uq-variant]');
    let variants;
    try { variants = JSON.parse(root.querySelector('[data-uspe-structured-variants]').textContent); }
    catch (_) { return; }
    const controls = [...box.querySelectorAll('[data-uspe-option-index]')];
    if (!native || !controls.length || !Array.isArray(variants)) return;
    const selected = variants.find(v => String(v.id) === native.value) || variants[0];
    controls.forEach((control, i) => { control.value = selected.options[i]; });
    box.addEventListener('change', () => {
      const requested = controls.map(control => control.value);
      const match = variants.find(v => v.options.every((value, i) => value === requested[i]));
      if (!match) return;
      native.value = String(match.id);
      native.dispatchEvent(new Event('change', { bubbles: true }));
    });
    native.addEventListener('change', () => {
      const current = variants.find(v => String(v.id) === native.value);
      if (current) controls.forEach((control, i) => { control.value = current.options[i]; });
      const sku = native.selectedOptions[0]?.dataset.model;
      if (sku) document.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
        try {
          const schema = JSON.parse(script.textContent);
          if (schema['@type'] !== 'Product' || !String(schema['@id'] || '').endsWith('#uspe-product')) return;
          schema.sku = sku;
          if (schema.brand?.name === 'USPE') schema.model = sku;
          script.textContent = JSON.stringify(schema);
        } catch (_) {}
      });
    });
    native.hidden = true;
    root.querySelector('label[for="' + native.id + '"]')?.setAttribute('hidden', '');
    box.hidden = false;
    box.dataset.ready = 'true';
  });
})();
